import * as rd from '@devexperts/remote-data-ts'

import { periodAsUnixTimeSelector } from '@/store/insertPeriodSlice'
import { licenseSlice } from '@/store/licenseSlice'
import { useAppSelector } from '../../hooks/store'
import { AppMode } from '../../models/app'
import { appSlice } from '../../store/appSlice'
import { bookingAvailabilitySlice } from '../../store/bookingAvailabilitySlice'

import { ChooseProductDefault } from './Default'
import { ChooseProductKiosk } from './Kiosk'

export const ChooseProductRoute = () => {
  const bookingAvailability = useAppSelector(
    bookingAvailabilitySlice.selectors.self
  )
  const areTicketsAvailable = useAppSelector(
    bookingAvailabilitySlice.selectors.areTicketsAvailable
  )
  const areSpotsAvailable = useAppSelector(
    bookingAvailabilitySlice.selectors.areSpotsAvailable
  )
  const license = useAppSelector(licenseSlice.selectors.license)
  const periodAsUnixTime = useAppSelector(periodAsUnixTimeSelector)
  const mode = useAppSelector(appSlice.selectors.mode)

  if (!rd.isSuccess(bookingAvailability) || !license || !periodAsUnixTime) {
    return null
  }

  if (mode === AppMode.KIOSK) {
    return (
      <ChooseProductKiosk
        areSpotsAvailable={areSpotsAvailable}
        areTicketsAvailable={areTicketsAvailable}
      />
    )
  }

  return (
    <ChooseProductDefault
      areSpotsAvailable={areSpotsAvailable}
      areTicketsAvailable={areTicketsAvailable}
    />
  )
}
